/* eslint-disable react/react-in-jsx-scope */
import DeleteMenuIcon from '../../assets/DeleteMenuIcon';
import EditPencil from '../../assets/EditPencil';

export const quizMenuList = [
  {
    name: 'Edit Quiz',
    icon: <EditPencil fontSize="small" />,
  },
  {
    name: 'Remove Quiz',
    icon: <DeleteMenuIcon fontSize="small" />,
  },
];

export const visibility = [
  { id: 1, name: 'DEALERSHIP' },
  { id: 2, name: 'GROUP' },
];
